import React, { useEffect, useRef, useState } from 'react'
import notificationIcon from '../../assets/icons/notification.svg';
import { useNotificationContext } from '../../contexts/NotificationContext';
import { formatDateFromNow } from '../../utils/converter';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const Notification = ({ id }) => {
    const { notifications, notificationCount, markAsReadNotification, markAllAsReadNotification } = useNotificationContext();
    const { content } = useContentfulContext();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(content.NOTIFICATION_CONTENT?.tab?.all || "all")
    const [data, setData] = useState([])

    const dropdownRef = useRef(null)

    useEffect(() => {
        switch (activeTab) {
            case content.NOTIFICATION_CONTENT?.tab?.local:
                setData(notifications.local);
                break;
            case content.NOTIFICATION_CONTENT?.tab?.global:
                setData(notifications.global);
                break;
            default:
                setData(notifications.all);
                break;
        }
    }, [notifications])

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsModalOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleOpenModal = () => {
        setIsModalOpen(true)
    }

    const handleMarkAsRead = async (item) => {
        if(!item?.is_read) {
            markAsReadNotification(item._id, item.type)
        }
        if (item?.deep_link?.startsWith('/ai-assistant-result?')) {
            window.dispatchEvent(new CustomEvent('assistant-result', { detail: item.deep_link }));
            setIsModalOpen(false);
        } else {
            window.open(item?.deep_link, '_blank');
        }
    }

    const handleChangeTab = (tab) => {
        setActiveTab(tab)
        switch (tab) {
            case 'local':
                setData(notifications.local);
                break;
            case 'global':
                setData(notifications.global);
                break;
            default:
                setData(notifications.all);
                break;
        }
    }
    return (
        <div id={id} className="relative" >
            <div className="relative cursor-pointer" onClick={handleOpenModal}>
                <img className="w-8 h-8" src={notificationIcon} alt="N" />
                {notificationCount?.allUnreadCount > 0 && <div className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs transform translate-x-1/2 -translate-y-1/2">
                    {notificationCount?.allUnreadCount}
                </div>}
            </div>
            {isModalOpen && <>
                <div
                    ref={dropdownRef}
                    className="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg overflow-hidden z-10"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                >
                    <div className="flex items-center justify-between border-b p-4">
                        <h2 className="text-xl font-semibold">{content.NOTIFICATION_CONTENT?.title}</h2>
                        <div className="flex items-center gap-4">
                            <button onClick={markAllAsReadNotification} className="text-sm text-primary hover:underline">
                                {content.NOTIFICATION_CONTENT?.mark_all_as_read}
                            </button>
                        </div>
                    </div>
                    <div className="flex border-b">
                        {[content.NOTIFICATION_CONTENT?.tab.all, content.NOTIFICATION_CONTENT?.tab.global, content.NOTIFICATION_CONTENT?.tab.local].map((tab) => (
                        <button
                            key={tab}
                            className={`flex-1 py-2 px-4 text-sm font-medium ${
                            activeTab === tab
                                ? 'border-b-2 border-primary text-primary'
                                : 'text-gray-500 hover:text-gray-700'
                            }`}
                            onClick={() => handleChangeTab(tab)}
                        >
                            {tab.charAt(0).toUpperCase() + tab.slice(1)}
                            {tab === content.NOTIFICATION_CONTENT?.tab.all && (notificationCount.allUnreadCount > 0) && <span className="ml-1 text-xs">({notificationCount.allUnreadCount})</span>}
                            {tab === content.NOTIFICATION_CONTENT?.tab.global && (notificationCount.globalUnreadCount > 0) && <span className="ml-1 text-xs">({notificationCount.globalUnreadCount})</span>}
                            {tab === content.NOTIFICATION_CONTENT?.tab.local && (notificationCount.localUnreadCount > 0) && <span className="ml-1 text-xs">({notificationCount.localUnreadCount})</span>}
                        </button>
                        ))}
                    </div>
                    <div className="max-h-96 overflow-y-auto">
                        {data.length == 0 && (
                            <p className='text-xl font-bold leading-tight tracking-tight text-gray-500 text-center my-4'>
                                {content.NOTIFICATION_CONTENT?.no_notification}
                            </p>
                        )}
                        {data.map((item) => (
                            <div
                                onClick={() => handleMarkAsRead(item)}
                                className={`cursor-pointer flex items-start gap-3 p-4 border-b last:border-b-0 ${!item.is_read && 'bg-blue-50'}`}
                            >
                                <div className="flex-1">
                                    <div className='flex justify-between'>
                                        <p className={`text-sm font-semibold`}>{item?.title}</p>
                                        <p className="text-xs text-gray-500 mt-1">{formatDateFromNow(item?.createdAt)}</p>
                                    </div>
                                    <p className="text-xs text-gray-500 mt-1">
                                        {item?.description && `• ${item?.description}`}
                                    </p>
                                </div>
                                {!item.is_read && (
                                    <div className="w-2 h-2 rounded-full bg-primary mt-2" aria-hidden="true"></div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </>}
        </div>
    )
}

export default Notification